module.exports = __webpack_public_path__ + "static/media/facebook-qr.e038c81d.jpg";